import { render, staticRenderFns } from "./search-about-dropdown.vue?vue&type=template&id=31eddf32&"
import script from "./search-about-dropdown.vue?vue&type=script&lang=ts&"
export * from "./search-about-dropdown.vue?vue&type=script&lang=ts&"
import style0 from "./search-about-dropdown.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports